module.exports = __webpack_public_path__ + "8a96edbbcd9a6991d79371aed0b0288e.woff";